import PropTypes from 'prop-types';
import find from 'lodash/find';
import React, { Component } from 'react';
import migrationEnabledCompanies, {
  migrationEnabledCompanyIds
} from 'helper/newLyearnRedirection/enabledCompanies';
import {
  getUserById,
  saveUser,
  getCompanyById,
  saveCompany
} from '../../helper/LearningSpaceServices/LocalStore';
import ConditionalLoader from '../ConditionalLoader';
import request from '../../helper/NetworkLayer';
import User from '../../helper/currentUser';
import saveUserCookies from '../../helper/saveUserCookies';
import handleLogout from '../../helper/handleLogout';
import reportRequest from '../../helper/ReportingDashboard';
import Events from '../../helper/ReportingDashboard/utils/eventsList';
import { userQuery } from './userQuery';

const user = new User();

class CurrentUserInit extends Component {
  static childContextTypes = {
    getCurrentUserInfo: PropTypes.func,
    getCurrentCompanyInfo: PropTypes.func,
    getParentCompanyInfo: PropTypes.func
  };

  state = { fetchingUser: true };

  getChildContext() {
    return {
      getCurrentUserInfo: this.getCurrentUserInfo,
      getCurrentCompanyInfo: this.getCurrentCompanyInfo,
      getParentCompanyInfo: this.getParentCompanyInfo
    };
  }

  async componentDidMount() {
    await this.fetchAndSetUserCompany();
    window.__refetchUserData = this.fetchAndSetUserCompany;
  }

  fetchAndSetUserCompany = async () => {
    const userId = user.id();
    const companyId = user.companyId();

    if (migrationEnabledCompanyIds.includes(companyId)) {
      const url = find(migrationEnabledCompanies, c => c.id === companyId).mappingUrl;

      try {
        const res = await fetch(url);
        const jsonRes = await res.json();
        window.migrationRedirectionsMap = jsonRes || {};
      } catch (e) {
        console.error('Error in fetching redirection mapping:' + url, e);
      }
    }
    if (!navigator.onLine) {
      const userFromIDB = await getUserById(userId);
      const companyFromIDB = await getCompanyById(companyId);
      if (userFromIDB && companyFromIDB) {
        this.setInfoAndSetState(userFromIDB, companyFromIDB);
      }
    }

    try {
      // Query only minimum top level user fields which are required.
      const response = await request('/graphql', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
          operationName: null,
          query: userQuery({ userId, companyId }),
          variables: {}
        })
      });

      const responseJSON = await response.json();
      const userInfo = responseJSON.data.user;
      const companyInfo = responseJSON.data.company;
      let parentCompanyInfo = '';

      if (
        companyInfo.parentCompanyId === '56e6c0675d63551300f1b690' ||
        companyInfo.parentCompanyId === '56bfef41a17441a959d9c8da'
      ) {
        const responseQuery = await request('/graphql', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify({
            operationName: null,
            query: `{
              company(id: "${companyInfo.parentCompanyId}") {
                pid
                name
                requiredAssetCustomProperties {
                  pid
                  name
                  values {
                    id
                    value
                  }
                }
            }
          }
          `,
            variables: {}
          })
        });
        const responseData = await responseQuery.json();
        parentCompanyInfo = responseData.data && responseData.data.company;
      }
      userInfo.company = companyInfo;

      if (userInfo.status === 'deleted') {
        throw new Error('User is deleted');
      }
      const promises = [saveCompany(companyInfo), saveUser(userInfo)];
      if (parentCompanyInfo) {
        promises.push(saveCompany(parentCompanyInfo));
      }
      await Promise.all(promises);
      this.setInfoAndSetState(userInfo, companyInfo, parentCompanyInfo);

      reportRequest(Events.APP_LOADED, {});
    } catch (err) {
      console.log('Error in fetching user', err);
      err && window.bugsnagClient && window.bugsnagClient.notify(err);
      this.state.fetchingUser && handleLogout('user_v_not_found');
    }
  };

  setInfoAndSetState = (userInfo, companyInfo, parentCompanyInfo) => {
    this.currentUserInfo = userInfo;
    window._currentUserInfo = userInfo;
    this.currentCompanyInfo = companyInfo;
    this.parentCompanyInfo = parentCompanyInfo;
    window._currentCompanyInfo = companyInfo;
    window._parentCompanyInfo = parentCompanyInfo;

    if (!user.isMasqueraded()) {
      saveUserCookies(
        userInfo.pid,
        userInfo.name,
        userInfo.companyId,
        userInfo.email,
        userInfo.picture,
        userInfo.roles,
        userInfo.company.parentCompanyId
      );
    }
    this.setState({ fetchingUser: false });
  };

  getCurrentUserInfo = () => this.currentUserInfo;

  getCurrentCompanyInfo = () => this.currentCompanyInfo;

  getParentCompanyInfo = () => this.parentCompanyInfo;

  render() {
    const { children } = this.props;

    return (
      <ConditionalLoader loading={this.state.fetchingUser} fullScreen={true} mode="dark">
        {children}
      </ConditionalLoader>
    );
  }
}

export default CurrentUserInit;
